import React, { useState } from 'react';
import { Grid, Typography, Container, Box, Rating, IconButton } from '@mui/material';
import { ArrowForward, ArrowBack } from '@mui/icons-material';

const feedbackData = [
  { rating: 5, text: 'Film Hook Media delivered exactly what we needed—calm, well-trained animals and professional handlers.', name: 'Ayesha Khan' },
  { rating: 5, text: 'They made our shoot seamless. The animals were handled with utmost care and precision.', name: 'Rohit Menon' },
  { rating: 4, text: 'Incredible service! The team from Film Hook Media ensured safety on set while delivering great results.', name: 'Sneha Pillai' },
  { rating: 5, text: 'We were impressed by their professionalism and expertise in handling animals during our commercial shoot.', name: 'Vikram Desai' },
  { rating: 5, text: 'The animals were camera-ready and the handlers were extremely cooperative. Highly recommended!', name: 'Meera Joseph' },
  { rating: 5, text: 'Film Hook Media made our wildlife-themed shoot hassle-free. Great coordination and trained animals!', name: 'Danish Iqbal' },
  { rating: 4, text: 'Fantastic experience. The animals were healthy and the shoot was smooth from start to end.', name: 'Tanvi Rao' },
  { rating: 5, text: 'Very professional, ethical treatment of animals, and great support throughout the film production.', name: 'Karan Bhatt' },
];

const avatarColors = ['#07a4f5', '#5dade2', '#a78bfa', '#4f83f7', '#60a5fa', '#07a4f5', '#5dade2', '#a78bfa'];
const initials = (name) => name.split(' ').map(n => n[0]).join('');

const CustomerFeedback = () => {
  const [startIndex, setStartIndex] = useState(0);
  const visibleCount = 4;

  const handleNext = () => { if (startIndex + visibleCount < feedbackData.length) setStartIndex(startIndex + 1); };
  const handlePrev = () => { if (startIndex > 0) setStartIndex(startIndex - 1); };

  return (
    <Box sx={{ py: { xs: 8, md: 10 }, px: { xs: 2, md: 4 } }}>
      <Container maxWidth="lg">
        <Box textAlign="center" mb={6}>
          <Typography variant="h3" fontWeight={800} sx={{ color: 'var(--text-heading)', mb: 1 }}>
            What Happy Clients Say
          </Typography>
          <Typography variant="body1" sx={{ color: 'var(--text-secondary)', mb: 2 }}>
            About Film-Hook Mediaapps Pvt. Ltd.
          </Typography>
          <Box sx={{ width: 60, height: 3, background: 'linear-gradient(90deg, #07a4f5, #5dade2)', mx: 'auto', borderRadius: '2px' }} />
        </Box>

        <Box display="flex" alignItems="center" gap={1}>
          {/* Left Arrow */}
          <IconButton
            onClick={handlePrev}
            disabled={startIndex === 0}
            sx={{
              background: startIndex === 0 ? 'rgba(255,255,255,0.04)' : 'linear-gradient(135deg, #07a4f5, #5dade2)',
              color: 'white',
              border: '1px solid var(--border-color)',
              '&:hover': { background: 'linear-gradient(135deg, #068bc2, #3498db)' },
              '&.Mui-disabled': { color: 'rgba(255,255,255,0.2)' },
              flexShrink: 0,
            }}
          >
            <ArrowBack />
          </IconButton>

          {/* Feedback Cards */}
          <Grid container spacing={2} sx={{ flex: 1 }}>
            {feedbackData.slice(startIndex, startIndex + visibleCount).map((feedback, index) => (
              <Grid
                item
                xs={12}
                sm={6}
                md={3}
                key={index}
                sx={{ display: { xs: index === 0 ? 'block' : 'none', sm: index < 2 ? 'block' : 'none', md: 'block' } }}
              >
                <Box
                  sx={{
                    background: 'var(--bg-card)',
                    backdropFilter: 'blur(16px)',
                    WebkitBackdropFilter: 'blur(16px)',
                    border: '1px solid var(--border-color)',
                    borderRadius: '20px',
                    p: 3,
                    height: '100%',
                    boxShadow: '0 8px 32px rgba(0,0,0,0.15)',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      border: '1px solid rgba(93,173,226,0.3)',
                      boxShadow: '0 16px 40px rgba(7, 164, 245,0.2)',
                    },
                  }}
                >
                  {/* Avatar */}
                  <Box
                    sx={{
                      width: 56, height: 56, borderRadius: '50%',
                      background: `linear-gradient(135deg, ${avatarColors[startIndex + index]}, ${avatarColors[(startIndex + index + 2) % avatarColors.length]})`,
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      mb: 2, fontWeight: 700, fontSize: '1.1rem', color: 'white',
                    }}
                  >
                    {initials(feedback.name)}
                  </Box>

                  <Rating value={feedback.rating} readOnly size="small" sx={{ mb: 1.5, '& .MuiRating-iconFilled': { color: '#5dade2' } }} />
                  <Typography variant="body2" sx={{ color: 'var(--text-secondary)', lineHeight: 1.7, mb: 2 }}>
                    "{feedback.text}"
                  </Typography>
                  <Typography variant="subtitle2" fontWeight={700} sx={{ color: 'var(--text-heading)' }}>
                    — {feedback.name}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>

          {/* Right Arrow */}
          <IconButton
            onClick={handleNext}
            disabled={startIndex + visibleCount >= feedbackData.length}
            sx={{
              background: startIndex + visibleCount >= feedbackData.length ? 'rgba(255,255,255,0.04)' : 'linear-gradient(135deg, #07a4f5, #5dade2)',
              color: 'white',
              border: '1px solid rgba(255,255,255,0.1)',
              '&:hover': { background: 'linear-gradient(135deg, #068bc2, #3498db)' },
              '&.Mui-disabled': { color: 'rgba(255,255,255,0.2)' },
              flexShrink: 0,
            }}
          >
            <ArrowForward />
          </IconButton>
        </Box>
      </Container>
    </Box>
  );
};

export default CustomerFeedback;
